
// const url = "https://raw.githubusercontent.com/PokeAPI/media/master/logo/pokeapi_256.png"

// const url =
//   "https://lh3.googleusercontent.com/5-w5yrCLD69zlOIfgMndRr4dMhrKW5u8nJVojvrUqnSI8ln1ywgqzNFjWQJYrN2YlVSBMHNyXzhcIrQXRPUYTcqJXjAzYbJyXiXb_uK3YO2G-g=e365-w1927";

const url =
  "https://lh3.googleusercontent.com/9FHOk79iiGEisBJxkU9smRi8CUKagEkt_yl7T7z9mEBHypSg5sblsGkv1YOxj-4vCpVbYUeo7dC6q2rxiHn9fNlcBxXGabLd7RpsNC6MHrwCRw=e365-w567";

export const featuredProduct = {
  product: "Pokemon",
  description: "Best pokemon sprites in the market.",
  image: url,
  imageText: "Available in all stores. 50% discount !!!",
};
